import { gql } from "@apollo/client";

const TOURNAMENTS = gql`
  query allTournamentNames(
    $page: Int
    $limit: Int
    $filter: ListTournamentInput
    $platform: Int
    $sports: [Int!]
    $organization: Int
    $startFrom: String
    $startTo: String
    $createdAtFrom: String
    $createdAtTo: String
    $isDashboard: Boolean
  ) {
    allTournamentNames(
      page: $page
      limit: $limit
      filter: $filter
      platform: $platform
      sports: $sports
      organization: $organization
      startFrom: $startFrom
      startTo: $startTo
      createdAtFrom: $createdAtFrom
      createdAtTo: $createdAtTo
      isDashboard: $isDashboard
    )
  }
`;

export default TOURNAMENTS;
